import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import { useMemo } from 'react';

import { getMe } from '../../../../api/user';
import { useTokenStore } from '../../../../store/tokenStore';
import { Me } from '../../../../type';
import { QueryKeys } from '../../../common/react-query/query-keys';

const useMeQuery = (
  options?: Omit<UseQueryOptions<Me | undefined>, 'queryKey' | 'queryFn'>,
) => {
  const token = useTokenStore.use.token();
  const setToken = useTokenStore.use.setToken();

  const queryResult = useQuery({
    queryKey: QueryKeys.getMe(token),
    queryFn: async () => {
      const { data } = await getMe();
      return data;
    },
    enabled: !!token,
    staleTime: 1000 * 60 * 60,
    meta: {
      onError: (e: AxiosError) => {
        /**
         * 401에러 발생시에만 토큰 초기화
         */
        if (axios.isAxiosError(e) && e.response?.status === 401) {
          setToken(null);
        }
      },
    },
    ...options,
  });

  return useMemo(
    () => ({
      ...queryResult,
      me: queryResult.data,
      refetchMe: queryResult.refetch,
    }),
    [queryResult],
  );
};

export default useMeQuery;
